import { useEffect, useState } from "react";
import "./AdminUsers.css";

const API =
  "https://mean3.com/backend/api/admin-users.php";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const rolePermissions = {
    admin: [
      "Full Admin Access",
      "Manage Blogs",
      "Create Blogs",
      "Edit Blogs",
      "Delete Blogs",
      "Publish Blogs",
      "Manage Users",
      "Manage Settings",
    ],

    dev: [
      "Full Development Access",
      "Manage Blogs",
      "Create Blogs",
      "Edit Blogs",
      "Delete Blogs",
      "Publish Blogs",
      "Manage Users",
      "Manage Settings",
    ],

    seo: [
      "Manage Blogs",
      "Create Blogs",
      "Edit Blogs",
      "Delete Blogs",
      "Publish Blogs",
    ],
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);

        const response = await fetch(`${API}?t=${Date.now()}`, {
          cache: "no-store",
        });

        const result = await response.json();

        if (!response.ok || !result.success) {
          throw new Error(result.message || "Unable to fetch users.");
        }

        setUsers(result.users || []);
      } catch (error) {
        console.error("FETCH USERS ERROR:", error);

        setError(error.message || "Unable to load users.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const getRoleClass = (role) => {
    return `user-role role-${role}`;
  };

  return (
    <div className="admin-users-page">
      <div className="admin-users-header">
        <div>
          <span className="admin-eyebrow">USER MANAGEMENT</span>

          <h1>Users & Permissions</h1>

          <p>Manage admin users and review their access rights.</p>
        </div>
      </div>

      {error && <div className="admin-error">{error}</div>}

      {loading ? (
        <div className="users-empty-state">
          <h3>Loading users...</h3>
        </div>
      ) : users.length === 0 ? (
        <div className="users-empty-state">
          <h3>No users found</h3>
        </div>
      ) : (
        <div className="users-grid">
          {users.map((user) => (
            <div className="user-card" key={user.id}>
              <div className="user-card-header">
                <div className="user-avatar">
                  {user.username?.charAt(0).toUpperCase()}
                </div>

                <div className="user-main-info">
                  <h2>{user.username}</h2>

                  <p>{user.email}</p>
                </div>

                <span className={getRoleClass(user.role)}>
                  {user.role}
                </span>
              </div>

              <div className="user-card-meta">
                <div>
                  <span>Status</span>

                  <strong className={`user-status ${user.status}`}>
                    {user.status}
                  </strong>
                </div>

                <div>
                  <span>User ID</span>

                  <strong>#{user.id}</strong>
                </div>
              </div>

              <div className="permissions-section">
                <h3>Access Rights</h3>

                <div className="permissions-list">
                  {rolePermissions[user.role]?.map((permission) => (
                    <span className="permission-badge" key={permission}>
                      ✓ {permission}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminUsers;